export default {
    hostname:  'https://krasnodar.krd-paren.ru' ,
   // hostname: typeof window === 'undefined' ? 'http://webserver' : 'https://krasnodar.krd-paren.ru',
    cookie_domain: '.krd-paren.ru',
    recapchaSiteKey: '6Lfp2PElAAAAANmhe5wfMWy_F3BvoQuhnIS5Tvht',
    sentryAuthToken: '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',
    hawkToken: 'eyJpbnRlZ3JhdGlvbklkIjoiNTVjZDJiNGMtNjU1ZC00NmZlLWIwN2YtMzZiYTk0YTU0MTI2Iiwic2VjcmV0IjoiZGZhYWU5ZWMtOTM2ZS00YzVmLTg2MjUtYjE2ZjJmM2VmY2Y1In0='
}

